import { combineReducers } from '@reduxjs/toolkit';
import claimsReducer from './claimsSlice';
import messagingReducer from './messagingSlice';
import userReducer from './userSlice';
import patientReducer from './patientSlice';
import lawyerReducer from './lawyerSlice';
import employerReducer from './employerSlice';
import insuranceReducer from './insuranceSlice';
import notesReducer from './notesSlice';
import providerReducer from './providerSlice';
import documentsReducer from './documentsSlice';
import callAgentReducer from './callAgentSlice';
import unifiedCallReducer from './unifiedCallSlice';
import vectorReducer from './vectorSlice';
import appointmentReducer from './appointmentSlice';
import chatQuestionsReducer from './chatQuestionsSlice';
import dataAgentSessionReducer from './dataAgentSessionSlice';
import dataAgentReducer from './dataAgentSlice';
import providerQuestionnaireReducer from './providerQuestionnaireSlice';
import queryProgressReducer from './queryProgressSlice';
import questionnaireReducer from './questionnaireSlice';
import realtimeReducer from './realtimeSlice';
import redFlagResolutionReducer from './redFlagResolutionSlice';
import redFlagReducer from './redFlagSlice';
import summaryReducer from './summarySlice';
import templateReducer from './templateSlice';
import userProfileReducer from './userProfileSlice';
import authReducer from './authSlice';
import batchesReducer from './batchesSlice';
import reconciliationReducer from './reconciliationSlice';
import taskReducer from './taskSlice';
import taskNotificationReducer from './taskNotificationSlice';
import emailSignatureReducer from './emailSignatureSlice';

const rootReducer = combineReducers({
  user: userReducer,
  claims: claimsReducer,
  patients: patientReducer,
  lawyers: lawyerReducer,
  employers: employerReducer,
  insurances: insuranceReducer,
  notes: notesReducer,
  providers: providerReducer,
  documents: documentsReducer,
  callAgent: callAgentReducer,
  unifiedCall: unifiedCallReducer,
  appointment: appointmentReducer,
  chatQuestions: chatQuestionsReducer,
  dataAgentSession: dataAgentSessionReducer,
  dataAgent: dataAgentReducer,
  providerQuestionnaire: providerQuestionnaireReducer,
  queryProgress: queryProgressReducer,
  questionnaire: questionnaireReducer,
  realtime: realtimeReducer,
  redFlagResolution: redFlagResolutionReducer,
  redFlag: redFlagReducer,
  summary: summaryReducer,
  template: templateReducer,
  userProfile: userProfileReducer,
  messaging: messagingReducer,
  auth: authReducer,
  vector: vectorReducer,
  batches: batchesReducer,
  reconciliation: reconciliationReducer,
  tasks: taskReducer,
  taskNotifications: taskNotificationReducer,
  emailSignature: emailSignatureReducer
});

export default rootReducer;
